import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import URLs from "source/app/services/External/URLs";
import { resourceNameRadioStation, IRadioStation } from "../../../../../../motw_core/Entity/IRadioStation";
import { IsMobileDevice } from "../../../domain/Device/Helpers/IsMobile";

let radioStations: IRadioStation[] = [];

export const GetCachedRadioStationsAsync = async () => {
    if (IsMobileDevice()) {
        return [];
    }

    if (radioStations.length) {
        return radioStations;
    }

    radioStations = await ClientDataProvider.GetRecordsAsync<IRadioStation>(
        resourceNameRadioStation
    );
    
    const newURLStations: IRadioStation[] = [];

    radioStations.forEach((station) => {
        var newUrl = station.url
            .replace("http://ice1.somafm.com/", `${URLs.mediaServer}somafm/`)
            .replace("-128-mp3", "");
        newURLStations.push({ ...station, url: newUrl });
    });

    radioStations = newURLStations;
    return radioStations;
};
